/* eslint-disable no-redeclare */
import { useSelector } from "src/store";

export enum StaffPermission {
  CAN_ACCESS_FINANCE_PAGE = "can_access_finance_page",
  CAN_ACCESS_ORDER_PAGE = "can_access_order_page",
  CAN_PURGE_SALES_RELATED_CACHE = "can_purge_sales_related_cache",
  CAN_MODIFY_MEMBERSHIP_UNLIMITED = "can_modify_membership_unlimited",
  CAN_COMMISSION_RATE_DISCOUNT = "can_commission_rate_discount",
  CAN_MAKE_PURCHASE_SETTLEMENT = "can_make_purchase_settlement",
  CAN_MAKE_PURCHASE_SETTLEMENT_TY = "can_make_purchase_settlement_ty",
  CAN_ACCESS_SUPPLEMENT_PAGE = "can_access_supplement_page",
  CAN_ACCESS_HOLIDAY_SHIPPING_SETTINGS = "can_access_holiday_shipping_settings",
  VENDOR_MANAGER_APPROVAL = "vendor_manager_approval",
  VENDOR_FINANCE_APPROVAL = "vendor_finance_approval",
}

// Function Overloads 根據呼叫時傳入的參數類型或數量來決定使用哪個函數定義
export function usePermission(permissionKey: StaffPermission[]): boolean[];
export function usePermission(permissionKey: StaffPermission): boolean;

export function usePermission(permissionKey?: StaffPermission | StaffPermission[]): boolean | boolean[] | null {
  const memberAccessToken = useSelector((state) => state.auth.memberAccessToken);
  if (!permissionKey) return null;
  const accessTokens = memberAccessToken || [];
  if (Array.isArray(permissionKey)) {
    return permissionKey.map((key) => accessTokens.includes(key));
  }

  return accessTokens.includes(permissionKey);
}
